/** @format */

import React, { useEffect, useState } from "react";
import Iconb from "../../extra/Iconb";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "../../extra/Button";
import Table from "../../extra/Table";
import { useDispatch, useSelector } from "react-redux";
import { deleteCondition, getCondition, toggleConditionActive } from "../../store/condition/condition.action";
import ConditionDialog from "./ConditionDialog";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { warning } from "../../../util/Alert";

const Condition = () => {
	const dispatch = useDispatch();
	const { condition } = useSelector((state) => state.condition);
	const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
	const [data, setData] = useState([]);

	useEffect(() => {
		dispatch(getCondition());
	}, []);

	useEffect(() => {
		setData(condition || []);
	}, [condition]);

	const handleDelete = (id) => {
		const data = warning();
		data.then((isDeleted) => {
			if (isDeleted) {
				dispatch(deleteCondition(id));
			}
		}).catch((err) => console.log(err));
	};

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span className='fw-normal'>{index + 1}</span>,
		},
		{
			Header: "Key",
			body: "key",
			Cell: ({ row }) => <p className='mb-0 fw-normal'>{row.key}</p>,
		},
		{
			Header: "Label",
			body: "label",
			Cell: ({ row }) => <p className='mb-0 text-capitalize fw-normal'>{row.label}</p>,
		},
		{
			Header: "Description",
			body: "description",
			Cell: ({ row }) => (
				<p className='mb-0 fw-normal' style={{ maxWidth: 360, whiteSpace: "normal" }}>
					{row.description}
				</p>
			),
		},
		{
			Header: "Icon",
			body: "icon",
			Cell: ({ row }) => <p className='mb-0 fw-normal'>{row.icon}</p>,
		},
		{
			Header: "Order",
			body: "sortOrder",
			Cell: ({ row }) => <p className='mb-0 fw-normal'>{row.sortOrder ?? 0}</p>,
		},
		{
			Header: "Active",
			body: "isActive",
			Cell: ({ row }) => (
				<label className='switch' style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}>
					<input type='checkbox' checked={!!row.isActive} onChange={() => dispatch(toggleConditionActive(row._id))} />
					<span style={{ marginLeft: 6 }}>{row.isActive ? "Yes" : "No"}</span>
				</label>
			),
		},
		{
			Header: "Edit",
			body: "",
			Cell: ({ row }) => (
				<Iconb
					newClass={`themeFont boxCenter infobtn userBtn fs-5`}
					btnIcon={<CreateOutlinedIcon sx={{ color: "#64748b" }} />}
					style={{
						borderRadius: "10px",
						margin: "auto",
						height: "45px",
						width: "45px",
						color: "#64748b",
					}}
					isImage={true}
					onClick={() => {
						dispatch({
							type: OPEN_DIALOGUE,
							payload: { data: row, type: "condition" },
						});
					}}
				/>
			),
		},
		{
			Header: "Delete",
			body: "",
			Cell: ({ row }) => (
				<Iconb
					newClass={`themeFont boxCenter killbtn userBtn fs-5`}
					btnIcon={<DeleteIcon sx={{ color: "#FF4C51" }} />}
					style={{
						borderRadius: "10px",
						margin: "auto",
						height: "45px",
						width: "45px",
						color: "#64748b",
						padding: "0px",
					}}
					isImage={true}
					isDeleted={true}
					onClick={() => handleDelete(row?._id)}
				/>
			),
		},
	];

	return (
		<>
			<div className='mainSellerTable'>
				<div className='sellerTable'>
					<div className='col-12 headname'>Listing Conditions</div>
					<div className='sellerMain'>
						<div className='tableMain mt-2 categoryTable'>
							<div className='sellerHeader primeHeader'>
								<div className='row'>
									<div className='col-12'>
										<Button
											newClass={`whiteFont`}
											btnColor={`btnBlackPrime `}
											btnIcon={`fa-solid fa-plus `}
											btnName={`Add`}
											onClick={() => {
												dispatch({
													type: OPEN_DIALOGUE,
													payload: { type: "condition" },
												});
											}}
											style={{ borderRadius: "8px", padding: "8px 32px", background: "#e54a13" }}
										/>
										{dialogue && dialogueType === "condition" && <ConditionDialog />}
									</div>
								</div>
							</div>
							<Table data={data} mapData={mapData} type={"client"} />
						</div>
					</div>
					<div className='sellerFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default Condition;
